import type { FinanceOptionType } from "../../../../common-deprecated/types/CommonTypes";
import type { UscCheckoutType } from "../../../shared-logic/types/UscCommonTypes";
import type { BasketConfigurationType } from "../../utils/basketUtils";
import {
    type UscBasketActionsType,
    USC_BASKET_SET_FINANCE_OPTION,
    USC_BASKET_SET_CHECKOUT_TYPE,
    USC_BASKET_ADD_ACCESSORY,
    USC_BASKET_REMOVE_ACCESSORY,
    USC_BASKET_ADD_PACK,
    USC_BASKET_REMOVE_PACK,
    USC_BASKET_SET_CONFIGURATION,
} from "../actions/UscBasketActions";

export type UscBasketReducerType = {
    activeFinanceOption: FinanceOptionType;
    checkoutType: UscCheckoutType | null;
    configuration: BasketConfigurationType;
};

export const initialStateUscBasket: UscBasketReducerType = {
    activeFinanceOption: "cash",
    checkoutType: null,
    configuration: {
        accessories: [],
        packs: [],
        services: [],
    },
};

const UscBasketReducer = (
    state: UscBasketReducerType = initialStateUscBasket,
    action: UscBasketActionsType,
): UscBasketReducerType => {
    switch (action.type) {
        case USC_BASKET_SET_FINANCE_OPTION: {
            return { ...state, activeFinanceOption: action.option };
        }

        case USC_BASKET_SET_CHECKOUT_TYPE: {
            return { ...state, checkoutType: action.checkoutType };
        }

        case USC_BASKET_ADD_ACCESSORY: {
            const { accessory } = action;

            if (!state.configuration.accessories.find((a) => a.id === accessory.id)) {
                return {
                    ...state,
                    configuration: {
                        ...state.configuration,
                        accessories: [...state.configuration.accessories, accessory],
                    },
                };
            }

            return state;
        }

        case USC_BASKET_REMOVE_ACCESSORY: {
            const { id } = action;

            return {
                ...state,
                configuration: {
                    ...state.configuration,
                    accessories: state.configuration.accessories.filter((accessory) => accessory.id !== id),
                },
            };
        }

        case USC_BASKET_ADD_PACK: {
            const { pack } = action;

            if (!state.configuration.packs.find((p) => p.id === pack.id)) {
                return {
                    ...state,
                    configuration: {
                        ...state.configuration,
                        packs: [...state.configuration.packs, pack],
                    },
                };
            }

            return state;
        }

        case USC_BASKET_REMOVE_PACK: {
            const { id } = action;

            return {
                ...state,
                configuration: {
                    ...state.configuration,
                    packs: state.configuration.packs.filter((pack) => pack.id !== id),
                },
            };
        }

        case USC_BASKET_SET_CONFIGURATION: {
            return {
                ...state,
                configuration: action.configuration,
            };
        }

        default:
            return state;
    }
};

export default UscBasketReducer;
